import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Checkbox } from '@/components/ui/checkbox';

export interface LocationItemData {
  id: string;
  type: 'building' | 'unit';
  label: string;
  sublabel?: string;
  buildingId: string;
  unitId?: string;
  instanceCount: number;
}

interface LocationItemProps {
  item: LocationItemData;
  isChecked: boolean;
  onToggle: (checked: boolean) => void;
}

const LocationItem: React.FC<LocationItemProps> = ({
  item,
  isChecked,
  onToggle,
}) => {
  return (
    <label
      className="flex items-center gap-2 rounded-md border bg-background px-3 py-2 hover:bg-accent/50 transition-colors cursor-pointer"
    >
      {/* Checkbox */}
      <Checkbox
        checked={isChecked}
        onCheckedChange={(checked) => onToggle(checked === true)}
      />

      {/* Info */}
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium truncate">{item.label}</div>
        {item.sublabel && (
          <div className="text-xs text-muted-foreground truncate">
            {item.sublabel}
          </div>
        )}
      </div>

      {/* Instance count badge */}
      {item.instanceCount > 0 && (
        <Badge variant="secondary" className="text-xs shrink-0">
          {item.instanceCount}
        </Badge>
      )}
    </label>
  );
};

export default LocationItem;
